import CustomScriptData from "./CustomScriptData";

const listAllDevices = new CustomScriptData(
    "List all Devices",
    `let devices = await bond.get("/devices");
print(\`Total Devices: \${Object.entries(devices).length - 2}\`);

for (const [deviceId, value] of Object.entries(devices)) {
  if(deviceId[0] === "_") continue;
  let device = await bond.get(\`/devices/\${deviceId}\`);
  print(\`\${deviceId} -- \${device.name}\`);  
}`);

const deleteAll = new CustomScriptData(
    "⚠️ Delete All Devices, Groups and Scenes ⚠️",
    `// Delete Devices
let devices = await bond.get("/devices");
let i = 1;
let totalDevices = Object.entries(devices).length - 2
print(\`# Total Devices: \${totalDevices}\`)

for (const [deviceId, value] of Object.entries(devices)) {
  if(deviceId[0] === "_") continue;
  await bond.delete(\`/devices/\${deviceId}\`);
  print(\`\${i}/\${totalDevices}\\tDeleted \${deviceId}\`);  
  i++;
}

// Delete Groups
let groups = await bond.get("/groups");
i = 1;
let totalGroups = Object.entries(groups).length - 2
print(\`# Total Groups: \${totalGroups}\`)

for (const [groupId, value] of Object.entries(groups)) {
  if(groupId[0] === "_") continue;
  await bond.delete(\`/groups/\${groupId}\`);
  print(\`\${i}/\${totalDevices}\\tDeleted \${groupId}\`);  
  i++;
}

// Delete Scenes
let scenes = await bond.get("/scenes");
i = 1;
let totalScenes = Object.entries(scenes).length - 2
print(\`# Total Scenes: \${totalScenes}\`)

for (const [sceneId, value] of Object.entries(scenes)) {
  if(sceneId[0] === "_") continue;
  await bond.delete(\`/scenes/\${sceneId}\`);
  print(\`\${i}/\${totalScenes}\\tDeleted \${sceneId}\`);  
  i++;
};`);


const maxSystem = new CustomScriptData(
    "Create Max System",
    `// Define variables
const TOTAL_LOCATIONS = 1
const TOTAL_DEVICES_BY_LOCATION = 2
const CREATE_SCENES_BY_LOCATION = true

const LOCATION_NAMES = [
    "Office", "Kitchen", "Bedroom", "Patio", "Suite",  
    "Living Room", "Dining Room", "Garage", "Basement", "Cellar"
];

const DEVICE_DATA = {
    "template": "RMS35", 
    "subtype": "BLACKOUT", 
    "properties":  {
        "feature_position": true, 
        "mfg": 5, 
        "pairing_assets_key": "powershades_rf"
    }
};

function createDeviceName(index, location, deviceData){
  return \`Device \${index}\`;
};

if(LOCATION_NAMES.lenght < TOTAL_LOCATIONS){ 
    throw new Error("Need more Location Names!"); 
}

let index = 1;
for(let i=0; i< TOTAL_LOCATIONS; i++){
  let location = LOCATION_NAMES[i];
  for(let j=0; j< TOTAL_DEVICES_BY_LOCATION; j++){
    let deviceName = createDeviceName(index, location, DEVICE_DATA);
    let createDeviceData = {
        "location": location, 
        "name": deviceName, 
        ...DEVICE_DATA
    }
    let  response = await bond.post("/devices", createDeviceData);
    print(\`
        # \${location} \${j+1}/\${TOTAL_DEVICES_BY_LOCATION}
        \${deviceName}: \${(await response.json())["_id"]}
    \`)
    index++;
  }
}`);

const upgradeFirmware = new CustomScriptData(
    "⚡️Upgrade Bond Firmware",
    `const TARGET = (await bond.get("/sys/version"))["target"];
const BRANCH = "alpha";
const VERSION = "v4.10.0-alpha"

async function loadFirmwareVersions(fwTarget, fwBranch) {
    const branchPath = ["alpha", "beta", "master"].indexOf(fwBranch) >= 0 ? \`\${fwBranch}-\${fwTarget}\`:fwBranch;
    const versionsUrl = \`https://s3.amazonaws.com/bond-updates/v2/\${fwTarget}/\${branchPath}/versions_internal.json\`;
    const result = await fetch(versionsUrl, {
        headers: {"Accept-Encoding": "gzip"}
    })
    const resultJson = await result.json();
    const versions = resultJson['versions']
    let versionsList = {}
    versions.forEach((v) => {
        versionsList[v['version']] = v
    })
    return versionsList
}

async function startUpgrade(fwVersionConfig){
    let response = await bond.put('/sys/upgrade', fwVersionConfig);
    while(true){
        let response = await bond.get('/sys/upgrade');
        let progress = parseInt(response["progress"]);
        print(\`Upgrading: \${progress / 10}%\`);
        if (progress === 1000) {
            let response = await bond.put('/sys/reboot', {})
            print("Rebooting...");
            await sleep(2000);
            break;
        } else if (progress === -1) {
            print(response);
            throw new Error(\`⚠️ Upgrade Error ⚠️\`);
        } else {
            await sleep(5000);
        }
    }
}

async function waitReboot(){
    while(true){
        try {
            let response = await bond.get('/sys/version');
            print("Upgrade Completed!");
            print(response);
            break;
        } catch {
            print("Waiting reboot...");
            await sleep(5000);
        }
    }
}

const fwVersions = await loadFirmwareVersions(TARGET, BRANCH);
const fwVersionConfig = fwVersions[VERSION];

if(!fwVersionConfig){ 
    alert(\`Version \${TARGET} - \${BRANCH} - \${VERSION} not found!\`);
    throw new Error(\`Version \${TARGET} - \${BRANCH} - \${VERSION} not found!\`);
}
    
await startUpgrade(fwVersionConfig);
await waitReboot();`);

export default [listAllDevices, maxSystem, deleteAll, upgradeFirmware];